import {client} from 'elevio'
import {WindowElev} from 'elevio/lib/elevio'

import {canOpenDixa, closeDixa} from './dixa'

type ElevioConfiguration = {
  enabled: boolean
  accountId: string
  dixaChatModuleId: number
  contactSalesModule?: number
  hiddenModuleIds?: number[]
  settings: Record<string, unknown> // https://api-docs.elevio.help/en/articles/41-setsettings
  language?: string
}

let isAvailable = false
let isOpen = false
let elevio: WindowElev // Elevio client instance

export const init = async (
  config: ElevioConfiguration,
  onModuleOpenedCallback?: (moduleId: number) => void
) => {
  if (config.enabled && config.accountId) {
    elevio = await client.load(config.accountId)

    elevio.on('load', () => {
      if (config.language) {
        elevio.setLanguage(config.language)
      }
      if (config.hiddenModuleIds && config.hiddenModuleIds.length > 1) {
        elevio.hideModules(config.hiddenModuleIds)
      }
    })
    // Called after Elevio has been initialised.
    elevio.on('ready', () => {
      const elevioElement = document.getElementById('_elev_io')
      isAvailable = !!elevioElement
    })
    elevio.on('widget:opened', () => {
      isOpen = true

      // always close dixa widget
      closeDixa()

      if (!canOpenDixa()) {
        elevio.hideModules([config.dixaChatModuleId])
      } else {
        elevio.showModules([config.dixaChatModuleId])
      }
    })
    elevio.on('module:opened', (moduleId: number) => {
      if (onModuleOpenedCallback) {
        onModuleOpenedCallback(moduleId)
      }
    })
    elevio.on('widget:closed', () => {
      isOpen = false
    })

    elevio.setSettings(config.settings)
  } else {
    // eslint-disable-next-line no-console
    console.info('*** Elevio disabled ***')
  }
}

export const isEnabled = () => isAvailable

export const show = () => {
  if (elevio && isAvailable) {
    elevio.open()
  }
}

export const hide = () => {
  // If we close the widget even though it was not open, we will see the widget and the closing animation very briefly
  if (elevio && isOpen) {
    elevio.close()
  }
}

export const openModule = (moduleId: number): void => {
  if (elevio) {
    elevio.openModule(`${moduleId}`)
  }
}
